export default "__VITE_ASSET__8nu6mi_N__"